import { useEffect } from 'react';

import { GlobalLogout, AuthChannelMessage } from './types';
import { eventEmitter } from '../../../services/eventEmitter';

const channel = new BroadcastChannel('auth_channel');
const currentTabId = Math.random().toString(36).substring(2);

const sendLogoutEvent = () => channel.postMessage({ type: 'logout', tabId: currentTabId });
const sendLoginEvent = () => channel.postMessage({ type: 'login', tabId: currentTabId });

export const useMultiTabLogout: GlobalLogout = () => {
	useEffect(() => {
		const handleMessage = (postMessageEvent: MessageEvent<AuthChannelMessage>) => {
			if (postMessageEvent.data.tabId === currentTabId) {
				return;
			}

			if (postMessageEvent.data.type === 'logout') {
				return eventEmitter.emit('logoutReceivedFromTab');
			}

			if (postMessageEvent.data.type === 'login') {
				return eventEmitter.emit('tokenRefreshed');
			}

			return;
		};

		channel.addEventListener('message', handleMessage);

		return () => {
			channel.removeEventListener('message', handleMessage);
			channel.close();
		};
	}, []);

	return { sendLogoutEvent, sendLoginEvent };
};
